module.exports = __webpack_public_path__ + "static/media/ARROZCAG_MENU-normal-1.1ad8fcc6.png";